import {
  EVENT_SCROLL_LOCK_ON_DISABLE,
  EVENT_SCROLL_LOCK_ON_DISABLE_START,
  EVENT_SCROLL_LOCK_ON_ENABLE,
  EVENT_SCROLL_LOCK_ON_ENABLE_START,
} from '../constants/event';

class ScrollLock {
  private static instance: ScrollLock;
  private htmlElement: HTMLElement | null = null;
  private isLocked: boolean = false;
  private scrollPosition: number = 0;
  private scrollbarWidth: number = 0;
  private scrollLockLayer: HTMLElement | null = null;

  private constructor() {
    this.htmlElement = document.documentElement;
    // スクロールバーの幅を計算
    this.scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;
  }

  public static getInstance(): ScrollLock {
    if (!ScrollLock.instance) {
      ScrollLock.instance = new ScrollLock();
    }
    return ScrollLock.instance;
  }

  public disable(): void {
    if (this.isLocked) return;
    document.dispatchEvent(new CustomEvent(EVENT_SCROLL_LOCK_ON_DISABLE_START));

    this.isLocked = true;
    const scrollY = window.scrollY;
    this.scrollPosition = scrollY;
    // スクロールバーの幅分だけ右パディングを追加
    document.body.style.paddingRight = `${this.scrollbarWidth}px`;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';

    document.dispatchEvent(
      new CustomEvent(EVENT_SCROLL_LOCK_ON_DISABLE, {
        detail: {
          scrollbarWidth: this.scrollbarWidth,
        },
      })
    );
  }

  public async enable(): Promise<void> {
    if (!this.isLocked) return;
    document.dispatchEvent(new CustomEvent(EVENT_SCROLL_LOCK_ON_ENABLE_START));

    this.isLocked = false;
    const scrollY = document.body.style.top;
    const originalScrollBehavior =
      document.documentElement.style.scrollBehavior;
    // スタイルをリセット
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    
    document.documentElement.style.scrollBehavior = 'auto';
    await new Promise((resolve) => requestAnimationFrame(resolve));
    window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
    document.documentElement.style.scrollBehavior = originalScrollBehavior;

    document.dispatchEvent(new CustomEvent(EVENT_SCROLL_LOCK_ON_ENABLE));
  }
}

export default ScrollLock;
